import { useMemo } from 'react'
import { useSelector } from 'react-redux'

/**
 * Resolves the Togo org flag (`togo_enabled`) for the org being VIEWED in Call
 * Explorer — a Balto admin or hierarchy manager can view a different org than the
 * one they're logged into, so we read the flag off the viewed org rather than the
 * current user's org. Falls back to the current org's flag only when the viewed
 * org isn't present in the loaded org list.
 *
 * @param {number|object} selectedOrgId - The org ID being viewed, or { value: orgId }
 * @returns {boolean} - Whether the viewed org has Togo enabled
 */
export const useTogoEnabled = (selectedOrgId) => {
  const { togo_enabled: currentOrgTogoEnabled } = useSelector((state) => state.currentOrganization)
  const { organizations } = useSelector((state) => state)

  const orgId = typeof selectedOrgId === 'object' ? selectedOrgId?.value : selectedOrgId

  return useMemo(() => {
    const viewedOrg = organizations?.find((org) => org.id === orgId)
    if (viewedOrg) {
      return Boolean(viewedOrg.togo_enabled)
    }
    return Boolean(currentOrgTogoEnabled)
  }, [organizations, orgId, currentOrgTogoEnabled])
}
